import React, { useState, useEffect } from "react";
import BusinessAdd from "../../components/common/BusinessAdd";
import CardHeader from "../../components/common/CardHeader";

function AddBusiness() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const handleResize = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarVisible(true);
    } else {
      setIsSidebarVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    //handleResize(); // Wywołanie przy montowaniu komponentu

    return () => window.removeEventListener("resize", handleResize); // Oczyszczenie przy demontowaniu
  }, []);

  return (
    <>
      <CardHeader text="Dodawanie powiązanej firmy" onlyText="true" />
      <BusinessAdd />
    </>
  );
}

export default AddBusiness;
